import { Box } from "@mui/material";
import { useStyles } from "./CorporateReports.styles";
import CorporateReportsFilters from "./components/CorporateReportsFilters/CorporateReportsFilters.view";
import TopFiveFailureCodesAllMills from "./components/TopFiveFailureCodesAllMills/TopFiveFailureCodesAllMills.view";
import TopFiveSecondaryFailureCodeAllMills from "./components/TopFiveSecondaryFailureCodeAllMills/TopFiveSecondaryFailureCodeAllMills.view";
import TotalDowntimeByMill from "./components/TotalDowntimeByMill/TotalDowntimeByMill.view";
import DowntimeFailureTypeByMill from "./components/DowntimeFailureTypeByMill/DowntimeFailureTypeByMill.view";
import DowntimeFailureCodeByMillReportCard from "./components/DowntimeFailureCodeByMillReportCard";
import DowntimeSecondaryFailureCodeByMillReportCard from "./components/DowntimeSecondaryFailureCodeByMillReportCard";
import { useTranslation } from "react-i18next";
import { useContext, useEffect, useState } from "react";
import { CorporateDashboardContext } from "contexts/CorporateDashboardContext/CorporateDashboardContext";
import { DowntimeSummaryByFailureType } from "./components/DowntimeSummaryByFailureType/DowntimeSummaryByFailureType.view";
import ReportCard from "components/ReportCard";
import { CorporationsEntity } from "entities/Corporations/CorporationsEntity";
import { CorporateContext } from "contexts/CorporateContext/CorporateContext";
import { translateDefaultEntity } from "utilities/localesUtilities";
import { DefaultTranslationFieldsInTable } from "constants/constants";

const CorporateReports = () => {
    const classes = useStyles();
    const { selectedFailureType, selectedFailureCode, handleSetCorporationCountryCode } =
        useContext(CorporateDashboardContext);
    const { corporations } = useContext(CorporateContext);
    const { t, i18n } = useTranslation();
    const { corporationCountryCode } = CorporationsEntity.GetCorporationCountryCode(corporations[0].corporate_id);
    const [countryCode, setCountryCode] = useState<string>("");

    const defaultFailureTypeTranslatedName = translateDefaultEntity(
        i18n.language,
        selectedFailureType,
        "name",
        DefaultTranslationFieldsInTable.FAILURE_TYPE,
    );

    useEffect(() => {
        if (corporationCountryCode) {
            setCountryCode(corporationCountryCode);
            handleSetCorporationCountryCode(corporationCountryCode);
        }
    }, [corporationCountryCode, handleSetCorporationCountryCode]);

    return (
        <Box className={classes.gridContainer}>
            <ReportCard>
                <CorporateReportsFilters />
            </ReportCard>
            <ReportCard title={t("corporate_dashboard.downtime_summary_by_type.title")}>
                <DowntimeSummaryByFailureType countryCode={countryCode} />
            </ReportCard>
            <ReportCard
                showNoData={!selectedFailureType}
                noDataTitle={t("corporate_dashboard.downtime_type_by_mill.no_data")}
                title={
                    selectedFailureType
                        ? t("corporate_dashboard.top_five_failure_codes_all_mills.title", {
                              failureType: defaultFailureTypeTranslatedName,
                          })
                        : t("corporate_dashboard.top_five_failure_codes_all_mills.title_no_selected")
                }
            >
                <TopFiveFailureCodesAllMills countryCode={countryCode} />
            </ReportCard>
            <ReportCard
                showNoData={!selectedFailureType || !selectedFailureCode}
                noDataTitle={t("corporate_dashboard.top_five_secondary_failure_codes_all_mills.no_data")}
                title={
                    selectedFailureCode
                        ? t("corporate_dashboard.top_five_secondary_failure_codes_all_mills.title", {
                              failureCode: defaultFailureTypeTranslatedName,
                          })
                        : t("corporate_dashboard.top_five_secondary_failure_codes_all_mills.title_no_selected")
                }
            >
                <TopFiveSecondaryFailureCodeAllMills countryCode={countryCode} />
            </ReportCard>
            <ReportCard title={t("corporate_dashboard.total_downtime_by_mill.title")}>
                <TotalDowntimeByMill countryCode={countryCode} />
            </ReportCard>
            <ReportCard
                showNoData={!selectedFailureType}
                noDataTitle={t("corporate_dashboard.downtime_type_by_mill.no_data")}
                title={
                    selectedFailureType
                        ? t("corporate_dashboard.downtime_type_by_mill.title", {
                              failureType: defaultFailureTypeTranslatedName,
                          })
                        : t("corporate_dashboard.downtime_type_by_mill.title_no_selected")
                }
            >
                <DowntimeFailureTypeByMill countryCode={countryCode} />
            </ReportCard>
            <DowntimeFailureCodeByMillReportCard countryCode={countryCode} />
            <DowntimeSecondaryFailureCodeByMillReportCard countryCode={countryCode} />
        </Box>
    );
};

export default CorporateReports;
